function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

module.exports = _nonIterableSpread;


//////////////////
// WEBPACK FOOTER
// ./~/jss-plugin-vendor-prefixer/~/css-vendor/~/@babel/runtime/helpers/nonIterableSpread.js
// module id = 1660
// module chunks = 0